import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, NgModule, Output } from '@angular/core';

@Component({
  selector: 'lp2-close-button',
  template: `
    <a (click)="onClick()">
      <i class="fa fa-times times-icon"></i>
    </a>
  `,
  styleUrls: ['./close-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CloseButtonComponent {
  @Output() click = new EventEmitter<void>();

  onClick() {
    this.click.emit();
  }
}

@NgModule({
  imports: [CommonModule],
  declarations: [CloseButtonComponent],
  exports: [CloseButtonComponent],
})
export class CloseButtonModule {}



// WEBPACK FOOTER //
// ./ts/app/components/close-button/close-button.component.ts